export const environment = {
  production: false,
  apiUrl: '/api',
  recaptchaSiteKey: '6LfFYwUuAAAAAJqm4Ao3C9_0eC5Cm_6VADeQZQdm',
};
